import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridModule } from '../grid/grid.module';
import { UBXIconModule } from '../icon/icon.module';
import { UBXButtonComponent } from './button.component';
import { UBXButtonGroupComponent } from './button-group/button-group.component';

const Imports = [
    UBXGridModule,
    UBXIconModule,
];
const Module = [
    UBXButtonComponent,
    UBXButtonGroupComponent,
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXButtonModule {}
